import React from "react";

const RefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-2xl shadow-md mt-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">
        Return, Cancellation & Refund Policy
      </h1>

      <section className="mb-6">
        <h2 className="text-lg font-semibold text-gray-700">1. Event Registration & Ticket Purchases</h2>
        <p className="text-gray-600 mt-2">
          Once you successfully register or purchase a ticket for an event through our platform,
          your participation is confirmed. All payments made are final, non-transferable, 
          and strictly non-refundable under any circumstances.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-lg font-semibold text-gray-700">2. Cancellation by Participant</h2>
        <p className="text-gray-600 mt-2">
          If you are unable to attend an event after registration, no cancellations or refunds 
          will be entertained. We encourage participants to carefully review event details before completing payment.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-lg font-semibold text-gray-700">3. Cancellation by Organizer</h2>
        <p className="text-gray-600 mt-2">
          In the rare case an event is canceled by the organizer, participants may be offered 
          a rescheduled date or the option to transfer their ticket to a future event. 
          Refunds will not be issued.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-lg font-semibold text-gray-700">4. Rescheduling or Venue Change</h2>
        <p className="text-gray-600 mt-2">
          If an event is rescheduled or the venue is changed, all tickets will remain valid. 
          In such cases, no refunds will be provided if a participant is unable to attend.
        </p>
      </section>

      <section>
        <h2 className="text-lg font-semibold text-gray-700">5. Contact for Queries</h2>
        <p className="text-gray-600 mt-2">
          For any event-related concerns or clarifications, please contact us at:
        </p>
        <ul className="mt-2 text-gray-600">
          <li>
            📧 Email:{" "}
            <a
              href="info@algo2botsinfotech.com"
              className="text-indigo-600 underline"
            >
              info@algo2botsinfotech.com
            </a>
          </li>
          {/* <li>📞 Phone: +91-XXXXXXXXXX</li> */}
        </ul>
      </section>
    </div>
  );
};

export default RefundPolicy;
